import React from 'react';
import { rem } from 'polished';
import styled from 'styled-components';
import { __ } from '../../../../Utils';
import { connect } from '../../../../Store';
import BaseList from '../../BaseList';
import PaintSystemCard from '../../../ProductCatalog/Components/PaintSystemsCard';
import API2 from '../../../../API2';

const TableHeader = styled.div`
  display: flex;
  align-items: center;
  overflow: scroll;
  height: ${rem(50)};
  margin-left: ${rem(20)};
  min-width: ${rem(1500)};
`;

const TableItem = styled.div`
  color: #434245;
  font-size: 14px;
  display: flex;
  align-items: center;
  height: ${rem(5)};
`;

const TableWrapper = styled.div`
  width: 100%;
  overflow-y: auto;
  white-space: nowrap;
`;

class PaintSystems extends BaseList {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: __('Náterové systémy'),
      notFoundMessage: __(
        'Ľutujeme, vyhľadávaniu nezodpovedajú žiadne výsledky ',
      ),
      limit: 5,
      isProduct: false,
      showFilter: this.props.productId ? false : true,
      showHeader: this.props.productId ? false : true,
      showPerSite: this.props.productId ? false : true,
      defaultFilter: [
        {
          id: 'type',
          values: ['NATEROVY_SYSTEM'],
        },
      ],
    };
  }

  componentDidMount() {
    const {
      actualPage,
      checkedFilter,
      offset,
      nextOffset,
      total,
      scrollPosition,
    } = this.loadActualData();
    let newCheckedFilter =
      checkedFilter && checkedFilter !== 'undefined'
        ? JSON.parse(checkedFilter)
        : [];

    if (!newCheckedFilter || newCheckedFilter.length === 0) {
      newCheckedFilter = this.state.defaultFilter;
    }

    this.setState(
      {
        actualPage:
          actualPage &&
          actualPage !== null &&
          actualPage !== 'null' &&
          actualPage > 0
            ? Number(actualPage)
            : 1,
        offset:
          offset && offset !== null && offset !== 'null' && offset > 0
            ? Number(offset)
            : 0,
        nextOffset:
          nextOffset &&
          nextOffset !== null &&
          nextOffset !== 'null' &&
          nextOffset > 0
            ? Number(nextOffset)
            : 0,
        total:
          total && total !== null && total !== 'null' && total > 0
            ? Number(total)
            : 0,
        checkedFilter: [...newCheckedFilter],
      },
      async () => {
        this.fetchFilter(false);
        this.fetchCombinedFilter();
        await this.fetchData({
          offset:
            offset && offset !== null && offset !== 'null' && offset > 0
              ? Number(offset)
              : 0,
          total,
        });

        window.scrollTo({
          top: scrollPosition ? Number(scrollPosition) : 0,
        });
        this.saveActualData(1, 0, null, [], null);
      },
    );
  }

  async fetchData(parameters = {}) {
    const { limit, checkedFilter, searchText } = this.state;
    const { productId } = this.props;

    try {
      const params = parameters;

      if (checkedFilter && !productId) {
        params.filters = {};
        const str = JSON.stringify({ filter: checkedFilter });
        params.filters = str;
      }

      if (!checkedFilter.find(c => c.id === 'type')) {
        checkedFilter.concat(this.state.defaultFilter);
      }

      if (searchText && searchText.length > 0) {
        params.q = searchText;
      }

      let newData = [];

      if (productId) {
        newData = await API2.getB2BCatalogProductPaintSystemsAction(
          productId,
          Object.assign(params, { limit }),
        );
      } else {
        newData = await API2.getB2BPaintSystemsAction(
          Object.assign(params, { limit }),
        );
      }
      this.setState({
        items: this.normalizeData(newData.paintSystems),
        loading: false,
        filtersDisabled: false,
        limit: newData.limit,
        offset: newData.offset,
        total: newData.total,
        nextOffset: newData.next_offset,
      });
    } catch (e) {
      this.setState({
        notFoundMessage: __('Pri načítaní dát sa vyskytla chyba'),
        loading: false,
      });
    }
  }

  openPaintSystem(id) {
    this.props.history.push(`/catalog/paint-systems/${id}`);
  }

  normalizeData(items) {
    if (!items) {
      return [];
    }

    return items.map(i =>
      Object.assign(i, {
        layers: this.normalizeLayers(i.layers),
      }),
    );
  }

  normalizeLayers(layers) {
    if (!layers) {
      return [];
    }
    const newLayers = [];
    const NUMBER_OF_LAYERS = 4;

    for (let i = 0; i <= NUMBER_OF_LAYERS - 1; i++) {
      if (layers[i]) {
        newLayers[i] = layers[i];
      } else {
        // newLayers.push({
        //   layer: '-',
        //   product_name: '',
        // });
      }
    }

    return newLayers;
  }

  renderItemsList() {
    const { items } = this.state;
    return (
      <TableWrapper>
        <TableHeader>
          <TableItem style={{ width: rem(80) }}>{__('Kód')}</TableItem>
          <TableItem style={{ width: rem(120) }}>{__('Kód výrobcu')}</TableItem>
          <TableItem style={{ width: rem(220) }}>{__('Povrch')}</TableItem>
          <TableItem style={{ width: rem(250) }}>{__('')}</TableItem>
          {/* <TableItem style={{ width: rem(150) }}>{__('')}</TableItem>
          <TableItem style={{ width: rem(150) }}>{__('')}</TableItem>
          <TableItem style={{ width: rem(150) }}>{__('')}</TableItem> */}
          <TableItem style={{ width: rem(100) }}>{__('HSF')}</TableItem>
          <TableItem style={{ width: rem(150) }}>{__('Značka')}</TableItem>
          <TableItem style={{ width: rem(120) }}>
            {__('Interér/Exteríer')}
          </TableItem>
          <TableItem style={{ width: rem(120) }}>{__('Typ systému')}</TableItem>
        </TableHeader>
        {items.map(p => {
          return (
            <PaintSystemCard onClick={e => this.openPaintSystem(e)} data={p} />
          );
        })}
      </TableWrapper>
    );
  }

  render() {
    return super.render();
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(PaintSystems);



// WEBPACK FOOTER //
// ./src/Containers/Buy/PaintSystems/List/index.jsx